// WhyChooseUsSection.jsx
import React from 'react';
import './WhyChooseUsSection.css';
import { Card, CardContent } from './ui/card';
import { Users, Clock, Zap, DollarSign } from 'lucide-react';
import { mockWhyChooseUs } from './mock';

const iconMap = {
  Users,
  Clock,
  Zap,
  DollarSign,
};

const WhyChooseUsSection = () => {
  return (
    <section id="why-choose" className="why-choose-section">
      <div className="why-choose-container">
        <div className="why-choose-header">
          <div className="why-choose-badge">Why Choose Us</div>
          <h2 className="why-choose-title">
            Trusted by Thousands of
            <span className="highlight-text"> Satisfied Clients</span>
          </h2>
          <p className="why-choose-description">
            We've built our reputation on delivering exceptional technical support with unmatched expertise and reliability.
          </p>
        </div>

        <div className="why-choose-grid">
          {mockWhyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="why-choose-card"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="why-choose-card-content">
                  <div className="why-choose-icon-wrapper">
                    <IconComponent className="why-choose-icon" />
                  </div>
                  <h3 className="why-choose-card-title">{item.title}</h3>
                  <p className="why-choose-card-text">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
